import React from 'react'
import style from './Geontracker.module.css'
import { useTranslation } from 'react-i18next'
import Presentacion from './comps/Presentacion'
import PrimeraParte from './comps/PrimeraParte'
import SegundaParte from './comps/SegundaParte'
import Solicitar from './comps/Solicitar'
import Carrusel from '../../carrusel/Carrusel'
import MasProductos from './comps/MasProductos'

const Geontracker = () => {
  const [t] = useTranslation();
  return (
    <div className={style.container}>
      <Presentacion t={t} />
      <PrimeraParte t={t} />
      <SegundaParte t={t} />
      <Solicitar t={t} />
      <Carrusel t={t} />
      <MasProductos t={t} />
    </div>
  )
}

export default Geontracker